import { render, staticRenderFns } from "./SupplierBaseData.vue?vue&type=template&id=32c6197e&scoped=true"
import script from "./SupplierBaseData.vue?vue&type=script&lang=js"
export * from "./SupplierBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c6197e",
  null
  
)

export default component.exports